// -----------------------------------------------------------------------------
export class LocalStorageValue {
  private readonly _value: string;

  // ---------------------------------------------------------------------------
  public constructor(value: string) {
    this._value = value;
  }

  // ---------------------------------------------------------------------------
  public get raw(): string | null {
    return this._value;
  }

  // ---------------------------------------------------------------------------
  public asBool(): boolean {
    return this._value && (this._value.toLowerCase() === 'true');
  }

  // ---------------------------------------------------------------------------
  public asInt(): number {
    return this._value && parseInt(this._value, 10);
  }

  // ---------------------------------------------------------------------------
  public asObject(): object {
    try {
      const obj = JSON.parse(this._value);
      return obj;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  public asArray(): any[] {
    try {
      const obj = JSON.parse(this._value);
      return obj;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  // ---------------------------------------------------------------------------
  public isNull(): boolean {
    return (this._value === null);
  }
}

// -----------------------------------------------------------------------------
export class LocalStorage {
  // ---------------------------------------------------------------------------
  public static get(key: string): LocalStorageValue {
    const val = localStorage.getItem(key);
    return new LocalStorageValue(val);
  }

  // ---------------------------------------------------------------------------
  public static set(key: string, val: any): void {
    if (!val) {
      val = '';
    }

    localStorage.setItem(key, val);
  }

  // ---------------------------------------------------------------------------
  public static setBool(key: string, val: boolean): void {
    localStorage.setItem(key, JSON.stringify(val));
  }

  // ---------------------------------------------------------------------------
  public static remove(key: string) {
    localStorage.removeItem(key);
  }

  // ---------------------------------------------------------------------------
  public static setObject(key: string, val: object): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(val));
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

}
